import { combineReducers } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import { configureStore } from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import { createLogger } from 'redux-logger'
import reducers from './reducers'
import storeRef, { persistorRef } from './storeRef'
import { USER_LOGOUT } from '../common/session'
import { PERSIST_KEY } from '../common/auth'

export default ({ authProvider, dataProvider }) => {
  const persistConfig = {
    // Env-scoped (e.g. 'UAT:root' -> localStorage 'persist:UAT:root') so
    // persisted permissions can't bleed across env builds on a shared origin.
    // The legacy 'persist:root' blob is deleted by the boot sweep.
    key: PERSIST_KEY,
    storage,
    whitelist: ['profile', 'auth'],
  }
  const rootReducer = combineReducers({
    ...reducers,
  })

  const persistedReducer = persistReducer(persistConfig, rootReducer)

  // Dispatched by clearSession() on logout/dead-token/impersonation-exit —
  // hands undefined to every reducer so all slices reset to their initial state.
  const resettableAppReducer = (state, action) =>
    persistedReducer(action.type !== USER_LOGOUT ? state : undefined, action)

  const store = configureStore({
    reducer: resettableAppReducer,
    middleware: (getDefaultMiddleware) => {
      const mw = getDefaultMiddleware({
        serializableCheck: false,
      })
      if (import.meta.env.DEV) {
        mw.push(createLogger())
      }
      return mw
    },
    devTools: import.meta.env.DEV,
  })

  storeRef.current = store
  const persistor = persistStore(store)
  persistorRef.current = persistor
  return { store, persistor }
}
